module.exports = __webpack_public_path__ + "static/media/on-eye_classic-SheerAllure.633b56e8.jpg";